import React from 'react'
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Button = ({ className, buttonText, style }) => {
  const [show,setShow]=React.useState(false)
  const copyCode = (e) => {
    setShow(true)
    toast(`Copied Code:${buttonText}`)

  }
  return (
    <div>
    <CopyToClipboard text={buttonText} onCopy={copyCode}>
      <button className={className} style={{ backgroundColor: `${style}` }}>{buttonText}</button>
      </CopyToClipboard>
      {show&&<ToastContainer />}
      </div>
  )
}

export default Button